/* FAST TECH — makes the WhatsApp number required on every add-to-cart form,
   including the theme's own product page form. */
(function () {
  var LABEL = window.FT_WA_LABEL || 'رقم الواتساب';
  var HELP = 'هنبعت لك السيريال عليه كمان بجانب الإيميل';
  var ERR = 'اكتب رقم صحيح — مثال: 01012345678';

  var CSS = [
    '.ft-wa-inj{margin:14px 0;direction:rtl;text-align:right;font-family:inherit}',
    '.ft-wa-inj label{display:block;font-size:.85rem;font-weight:700;margin-bottom:6px}',
    '.ft-wa-inj label i{color:#E64BB4;font-style:normal}',
    '.ft-wa-inj input{width:100%;box-sizing:border-box;padding:12px 14px;border-radius:10px;',
    'border:1px solid rgba(128,128,128,.45);background:transparent;color:inherit;',
    'font-family:inherit;font-size:.95rem;direction:ltr;text-align:left}',
    '.ft-wa-inj input:focus{outline:none;border-color:#22D3EE;box-shadow:0 0 0 3px rgba(34,211,238,.18)}',
    '.ft-wa-inj input:user-invalid{border-color:#F87171}',
    '.ft-wa-inj small{display:block;opacity:.7;font-size:.75rem;margin-top:5px;line-height:1.6}'
  ].join('');

  function style() {
    if (document.getElementById('ft-wa-css')) return;
    var s = document.createElement('style');
    s.id = 'ft-wa-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function alreadyHas(form) {
    var ins = form.querySelectorAll('input[name^="properties["]');
    for (var i = 0; i < ins.length; i++) {
      if (/واتس|whats|phone/i.test(ins[i].name)) return true;
    }
    return false;
  }

  function build(id) {
    var w = document.createElement('div');
    w.className = 'ft-wa-inj';
    w.setAttribute('data-ft-wa', '1');
    var lab = document.createElement('label');
    lab.setAttribute('for', id);
    lab.innerHTML = LABEL + ' <i>*</i>';
    var inp = document.createElement('input');
    inp.type = 'tel';
    inp.id = id;
    inp.name = 'properties[' + LABEL + ']';
    inp.required = true;
    inp.minLength = 9;
    inp.maxLength = 20;
    inp.setAttribute('inputmode', 'tel');
    inp.setAttribute('autocomplete', 'tel');
    inp.setAttribute('pattern', '[0-9+][0-9 \\-]*');
    inp.setAttribute('placeholder', '01xxxxxxxxx');
    inp.title = ERR;
    var hint = document.createElement('small');
    hint.textContent = HELP;
    w.appendChild(lab); w.appendChild(inp); w.appendChild(hint);
    return w;
  }

  var n = 0;
  function inject() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.querySelector('[data-ft-wa]') || alreadyHas(f)) continue;
      style();
      var field = build('ft-wa-' + (++n));
      var btn = f.querySelector('button[type="submit"], [type="submit"]');
      if (btn && btn.parentNode) {
        (btn.closest('.product-form-buttons') || btn.parentNode).insertBefore(
          field,
          btn.closest('.product-form-buttons') ? btn.closest('.product-form-buttons').firstChild : btn
        );
      } else {
        f.appendChild(field);
      }
    }
  }

  function boot() {
    inject();
    if (window.MutationObserver) {
      new MutationObserver(function () { inject(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
